import React from "react";
import { useNavigate } from "react-router-dom";
import "./MainLandingPage.css";
import mapImg from "../assets/live.jpeg";
import logo from "../assets/d37h13dk.png";
import FadeInSection from "../FadeInSection/FadeInSection";

const MainLandingPage = () => {
    const navigate = useNavigate();
const highwayPoints = [
  { top: "10%", left: "55%", path: "/highway/1" },
  { top: "15%", left: "60%", path: "/highway/2" },
  { top: "20%", left: "65%", path: "/highway/3" },
  { top: "30%", left: "70%", path: "/highway/4" },
  { top: "40%", left: "75%", path: "/highway/5" },
];
    return (
        <div className="pg-container">

            <section className="pg-map animate-zoom">
                <FadeInSection>

                    {/* ROW */}
                    <div className="card-row">

                        {/* LEFT CARD : MAP */}
                        <div className="map-card">
                            <div className="map-wrapper">
                                <img src={mapImg} alt="Map" className="map-img" />

                                {/* <div className="map-pin" style={{ top: "25.5%", left: "74.1%" }} onClick={() => navigate("/location/yadadri")} title="Yadadri" /> */}
                                <div className="map-pin" style={{ top: "41.5%", left: "60.8%" }}  
                                 onClick={() =>
                         navigate("/highways", {
                     state: { highway: "WARANGAL HIGHWAY" }
                          })}
                                   title="WARANGAL HIGHWAY" />
                                 <div className="map-pin" style={{ top: "51.5%", left: "59.8%" }} title="VIJAYAWADA HIGHWAY" />
                                       onClick={() =>
                         navigate("/highways", {
                     state: { highway: "VIJAYAWADA HIGHWAY" }
                          })}

                                 <div className="map-pin" style={{ top: "57.5%", left: "55.8%" }} 
                                       onClick={() =>
                         navigate("/highways", {
                     state: { highway: "NAGARJUNA SAGAR HIGHWAY" }
                          })}
                          title="NAGARJUNA SAGAR HIGHWAY" />
                                 
                                 <div className="map-pin" style={{ top: "60.5%", left: "50%" }}
                                       onClick={() =>
                         navigate("/highways", {
                     state: { highway: "SRISAILAM HIGHWAY" }
                          })}
                           title="SRISAILAM HIGHWAY" />
                                 <div className="map-pin" style={{ top: "58.5%", left: "44.8%" }}
                                       onClick={() =>
                         navigate("/highways", {
                     state: { highway: "BANGLORE HIGHWAY" }
                          }) }title="BANGLORE HIGHWAY" />

                                 
                                 <div className="map-pin" style={{ top: "48.5%", left: "45%" }}
                                       onClick={() =>
                         navigate("/highways", {
                     state: { highway: "MOINABAD VIKARABAD HIGHWAY" }
                          })} title="MOINABAD VIKARABAD HIGHWAY" />

                                {/* <div className="map-pin" style={{ top: "34.5%", left: "67.8%" }} onClick={() => navigate("/location/bhuvanagiri")} title="bhuvanagiri" />
                                <div className="map-pin" style={{ top: "13.2%", left: "68.1%" }} onClick={() => navigate("/location/pragnapur")} title="Pragnapur" />
                                <div className="map-pin" style={{ top: "7.2%", left: "57.5%" }} onClick={() => navigate("/location/gajwel")} title="Gajwel" />
                                <div className="map-pin" style={{ top: "4.2%", left: "49.4%" }} onClick={() => navigate("/location/masaipet")} title="Masaipet" /> */}
                                 <div className="map-pin" style={{ top: "33.2%", left: "38.1%" }}
                                       onClick={() =>
                         navigate("/highways", {
                     state: { highway: "MUMBAI HIGHWAY" }
                          })}
                            title="MUMBAI HIGHWAY" />
                                  <div className="map-pin" style={{ top: "29.2%", left: "47.1%" }}
                                        onClick={() =>
                         navigate("/highways", {
                     state: { highway: "MEDAK HIGHWAY" }
                          })}
                            title="MEDAK HIGHWAY" />
                                  <div className="map-pin" style={{ top: "29.2%", left: "51.1%" }}
                                        onClick={() =>
                         navigate("/highways", {
                     state: { highway: "Nagpur HIGHWAY" }
                          })}  title="Nagpur highway" />

                                <div className="map-pin" style={{ top: "30.2%", left: "55.1%" }}
                                      onClick={() =>
                         navigate("/highways", {
                     state: { highway: "KARIMNAGAR HIGHWAY" }
                          })}
                            title="KARIMNAGAR HIGHWAY" />
                                {/* <div className="map-pin" style={{ top: "11.2%", left: "50.1%" }} onClick={() => navigate("/location/toopran")} title="Toopran" />
                                <div className="map-pin" style={{ top: "25%", left: "37.2%" }} onClick={() => navigate("/location/narsapur")} title="Narsapur" />
                                <div className="map-pin" style={{ top: "24.5%", left: "24.8%" }} onClick={() => navigate("/location/sangareddy")} title="sangareddy" />
                                <div className="map-pin" style={{ top: "41.5%", left: "22.2%" }} onClick={() => navigate("/location/nawabpet")} title="nawabpet" />
                                <div className="map-pin" style={{ top: "56.5%", left: "34.4%" }} onClick={() => navigate("/location/chevella")} title="chevella" />
                                <div className="map-pin" style={{ top: "66.5%", left: "31%" }} onClick={() => navigate("/location/shabad")} title="shabad" />
                                <div className="map-pin" style={{ top: "75.5%", left: "35%" }} onClick={() => navigate("/location/shadnagar")} title="shadnagar" />
                                <div className="map-pin" style={{ top: "79.5%", left: "42.3%" }} onClick={() => navigate("/location/keshampet")} title="keshampet" />
                                <div className="map-pin" style={{ top: "89.5%", left: "46.8%" }} onClick={() => navigate("/location/Amangal")} title="Amangal" />
                                <div className="map-pin" style={{ top: "79.1%", left: "57.8%" }} onClick={() => navigate("/location/nagilla")} title="Nagilla" />
                                <div className="map-pin" style={{ top: "89.1%", left: "61.4%" }} onClick={() => navigate("/location/mallkurmapally")} title="Mall-Kurmapally" />
                                <div className="map-pin" style={{ top: "83.1%", left: "70.7%" }} onClick={() => navigate("/location/marrigudem")} title="Marrigudem" />
                                <div className="map-pin" style={{ top: "73.4%", left: "72.9%" }} onClick={() => navigate("/location/shivannaguda")} title="Shivannaguda" />
                                <div className="map-pin" style={{ top: "66.6%", left: "75.4%" }} onClick={() => navigate("/location/samsthan-narayanpur")} title="Samsthan Narayanpur" />
                                <div className="map-pin" style={{ top: "56.2%", left: "76.5%" }} onClick={() => navigate("/location/choutuppal")} title="Choutuppal" />
                                <div className="map-pin" style={{ top: "46.4%", left: "79.4%" }} onClick={() => navigate("/location/valigonda")} title="Valigonda" /> */}
                           {/* {highwayPoints.map((point, index) => (
      <div
        key={index}
      className="map-pin highway-pin"
      style={{ top: point.top, left: point.left }}
       onClick={() => navigate(point.path)}
       title={`Highway Point ${index + 1}`}
     />
          ))} */}
                           
                            </div>
                        </div>

                        {/* RIGHT CARD : WELCOME */}
                        <div className="welcome-card">
                            <img src={logo} alt="Logo" className="auth-logo" />
                            <h2>Welcome to Property Galleria</h2>
                            <p> Discover premium project locations and manage your investments with confidence. </p>
                            <button onClick={() => navigate("/login")}>Login</button>
                            <button className="signup" onClick={() => navigate("/choose-role")}>Sign Up</button>
                        </div>

                    </div>

                </FadeInSection>
            </section>


        </div>
    );
};

export default MainLandingPage;
